var _Colors;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
// ----------------------------------------------------------------------------
// Helper: ANSI Colors (Chrome only)
// ----------------------------------------------------------------------------
// Original source: https://github.com/sindresorhus/yoctocolors/tree/main
// Modified by iamota for simplicity
//
// Example usage:
// ----------------------------------------------------------------------------
// import Colors from './colors';
// console.log(Colors.red("hello"));
// console.log(Colors.greenBright("bright green"));
// ----------------------------------------------------------------------------

class Colors {
  static format(open, close) {
    if (!this.hasColors) {
      return input => input;
    }
    var openCode = "\x1B[".concat(open, "m");
    var closeCode = "\x1B[".concat(close, "m");
    return input => {
      var string = input + '';
      var index = string.indexOf(closeCode);
      if (index === -1) {
        return openCode + string + closeCode;
      }
      var result = openCode;
      var lastIndex = 0;
      while (index !== -1) {
        result += string.slice(lastIndex, index) + openCode;
        lastIndex = index + closeCode.length;
        index = string.indexOf(closeCode, lastIndex);
      }
      result += string.slice(lastIndex) + closeCode;
      return result;
    };
  }

  // Static methods for text formatting
}
_Colors = Colors;
_defineProperty(Colors, "hasColors", typeof navigator !== 'undefined' && /Chrome/.test(navigator.userAgent));
_defineProperty(Colors, "reset", _Colors.format(0, 0));
_defineProperty(Colors, "bold", _Colors.format(1, 22));
_defineProperty(Colors, "dim", _Colors.format(2, 22));
_defineProperty(Colors, "italic", _Colors.format(3, 23));
_defineProperty(Colors, "underline", _Colors.format(4, 24));
_defineProperty(Colors, "overline", _Colors.format(53, 55));
_defineProperty(Colors, "inverse", _Colors.format(7, 27));
_defineProperty(Colors, "hidden", _Colors.format(8, 28));
_defineProperty(Colors, "strikethrough", _Colors.format(9, 29));
// Static methods for foreground colors
_defineProperty(Colors, "black", _Colors.format(30, 39));
_defineProperty(Colors, "red", _Colors.format(31, 39));
_defineProperty(Colors, "green", _Colors.format(32, 39));
_defineProperty(Colors, "yellow", _Colors.format(33, 39));
_defineProperty(Colors, "blue", _Colors.format(34, 39));
_defineProperty(Colors, "magenta", _Colors.format(35, 39));
_defineProperty(Colors, "cyan", _Colors.format(36, 39));
_defineProperty(Colors, "white", _Colors.format(37, 39));
_defineProperty(Colors, "gray", _Colors.format(90, 39));
// Static methods for background colors
_defineProperty(Colors, "bgBlack", _Colors.format(40, 49));
_defineProperty(Colors, "bgRed", _Colors.format(41, 49));
_defineProperty(Colors, "bgGreen", _Colors.format(42, 49));
_defineProperty(Colors, "bgYellow", _Colors.format(43, 49));
_defineProperty(Colors, "bgBlue", _Colors.format(44, 49));
_defineProperty(Colors, "bgMagenta", _Colors.format(45, 49));
_defineProperty(Colors, "bgCyan", _Colors.format(46, 49));
_defineProperty(Colors, "bgWhite", _Colors.format(47, 49));
_defineProperty(Colors, "bgGray", _Colors.format(100, 49));
// Static methods for bright foreground colors
_defineProperty(Colors, "redBright", _Colors.format(91, 39));
_defineProperty(Colors, "greenBright", _Colors.format(92, 39));
_defineProperty(Colors, "yellowBright", _Colors.format(93, 39));
_defineProperty(Colors, "blueBright", _Colors.format(94, 39));
_defineProperty(Colors, "magentaBright", _Colors.format(95, 39));
_defineProperty(Colors, "cyanBright", _Colors.format(96, 39));
_defineProperty(Colors, "whiteBright", _Colors.format(97, 39));
// Static methods for bright background colors
_defineProperty(Colors, "bgRedBright", _Colors.format(101, 49));
_defineProperty(Colors, "bgGreenBright", _Colors.format(102, 49));
_defineProperty(Colors, "bgYellowBright", _Colors.format(103, 49));
_defineProperty(Colors, "bgBlueBright", _Colors.format(104, 49));
_defineProperty(Colors, "bgMagentaBright", _Colors.format(105, 49));
_defineProperty(Colors, "bgCyanBright", _Colors.format(106, 49));
_defineProperty(Colors, "bgWhiteBright", _Colors.format(107, 49));
export default Colors;